// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.
//
// export const environment = {
//   production: false,
//   baseUrl: 'https://2w4kkexmm3.execute-api.us-east-1.amazonaws.com',
//   cookieDomain: 'localhost',
// };
// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.
//
// export const environment = {
//   production: false,
//   baseUrl: 'https://h36iklb3ic.execute-api.us-east-1.amazonaws.com',
//   cookieDomain: 'd1s2idq8ih7w7o.cloudfront.net',
// };

// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.
//
// export const environment = {
//   production: false,
//   baseUrl: 'https://d2t4s35ezyb8b7.cloudfront.net/api/v1',
//   cookieDomain: 'bindal.ysoftsolutions.co.uk',
// };
export const environment = {
  production: process.env.NODE_ENV === 'production',
  baseUrl: process.env.REACT_APP_BASE_URL ?? 'http://localhost:3000',
  cookieDomain: process.env.REACT_APP_COOKIE_DOMAIN ?? 'localhost',
};
